const r = [
  ["workersCreated", "workersTerminated", "workers"],
  ["connectionsOpened", "connectionsClosed", "connections"],
  ["filesRegistered", "filesDropped", "files"],
  ["listenersAdded", "listenersRemoved", "listeners"]
], t = () => ({
  workersCreated: 0,
  workersTerminated: 0,
  connectionsOpened: 0,
  connectionsClosed: 0,
  filesRegistered: 0,
  filesDropped: 0,
  listenersAdded: 0,
  listenersRemoved: 0
});
let e = t();
function i() {
  return { ...e };
}
function a() {
  e = t();
}
function l(s, n = 1) {
  e[s] += n;
}
function c() {
  return r.every(
    ([s, n]) => e[s] === e[n]
  );
}
function d() {
  return r.filter(
    ([s, n]) => e[s] !== e[n]
  ).map(
    ([s, n, o]) => `${o}: ${e[s]} acquired vs ${e[n]} released`
  ).join("; ");
}
globalThis.__duckdbResourceStats = () => ({
  ...i(),
  balanced: c(),
  imbalance: d()
});
export {
  l as bumpResourceStat,
  d as describeResourceImbalance,
  i as getResourceStats,
  c as isResourceBalanced,
  a as resetResourceStats
};
